module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        loyaltyTier: {
            type: 'string'
        },
        customerInfoProcessed: {
            type: 'boolean'
        },
        beType: {
            type: 'string'
        },
        isTemporary: {
            type: 'boolean'
        },
        targetGroups: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    }
}
